import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["placeholder", "aria-describedby", "aria-required", "aria-invalid", "id", "autocomplete"]
const _hoisted_2 = ["placeholder", "aria-describedby", "aria-required", "aria-invalid", "id", "autocomplete"]
const _hoisted_3 = ["placeholder", "aria-describedby", "aria-required", "aria-invalid", "id"]

import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import VueMultiselect from 'vue-multiselect';
import { PropType, ref, watch, inject, Ref, computed } from "vue";
import { Address, LookupResponse } from "@/interfaces";
import { PageDesign } from "../../interfaces";
import { FieldStyle, PartialDisplayType } from "@/builder/enums";
import { useRenderStore } from "../../stores/renderStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'DomesticAddress',
  props: {
    id: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    address: {
        type: Object as PropType<Address>,
        required: true
    },
    showAddress2: {
        type: Boolean,
        required: false,
        default: true,
    },
    states: {
        type: Array as PropType<LookupResponse[]>,
        required: true
    },
    required: {
        type: Boolean,
        required: false,
        default: false,
    },
    address2Label: {
        type: String,
        required: false,
        default: "",
    },
    address2Placeholder: {
        type: String,
        required: false,
        default: "Address Line 2",
    },
    cityLabel: {
        type: String,
        required: false,
        default: "",
    },
    cityPlaceholder: {
        type: String,
        required: false,
        default: "City",
    },
    stateLabel: {
        type: String,
        required: false,
        default: "",
    },
    statePlaceholder: {
        type: String,
        required: false,
        default: "State",
    },
    postalLabel: {
        type: String,
        required: false,
        default: "",
    },
    postalPlaceholder: {
        type: String,
        required: false,
        default: "Postal",
    },
    isShipping: {
        type: Boolean,
        required: false,
        default: false,
    }
},
  emits: ['update-address'],
  setup(__props, { emit: __emit }) {

const props = __props;

const renderStore = useRenderStore();

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});

const emit = __emit;

const stateSelection = ref(null as LookupResponse | null);

const address = ref(props.address);
const isStateOpen = ref(false);

const isModalDisplay = computed(() => {
    return renderStore.page.partialDisplayType === PartialDisplayType.Modal;
})

//watch for prop address state changes, map to state selection
watch(() => props.address.state, (newVal) => {
    //map to the state object
    const matchedState = props.states.find(x => x.value === newVal);
    if (matchedState) {
        stateSelection.value = matchedState;
    }
    else {
        stateSelection.value = null;
    }
},
    {
        deep: true
    });

//watch for state selection changes, map to address state
watch(() => stateSelection.value, (newVal) => {
    if (newVal) {
        address.value.state = newVal.value;
    }
});

//watch for props states to populate state selection
watch(() => props.states, (newVal) => {
    //map to the state object
    const matchedState = newVal.find(x => x.value === props.address.state);
    if (matchedState) {
        stateSelection.value = matchedState;
    }
});

//watch for changes to address, emit update
watch(() => address, (newVal) => {
    emit('update-address', newVal);
},
    {
        deep: true
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showAddress2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["form-row", [{ 'rd-mt-4': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value }, { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]])
        }, [
          _createVNode(ValidatedInput, {
            id: __props.id,
            value: address.value.address2,
            label: __props.address2Label,
            accessibleLabel: __props.address2Placeholder,
            class: "rd-w-full",
            name: __props.name + '.Address.Address2',
            maxLength: 75
          }, {
            input: _withCtx((inputProps) => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address.value.address2) = $event)),
                placeholder: __props.address2Placeholder,
                "aria-describedby": inputProps.describedBy ?? undefined,
                "aria-required": inputProps.required,
                "aria-invalid": inputProps.isInvalid,
                id: __props.id + '_' + __props.name + '.Address.Address2',
                autocomplete: __props.isShipping ? 'shipping address-line2' : 'billing address-line2'
              }, null, 8, _hoisted_1), [
                [_vModelText, address.value.address2]
              ])
            ]),
            _: 1
          }, 8, ["id", "value", "label", "accessibleLabel", "name"])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["form-row", [{ 'rd-mt-0 md:rd-gap-x-4 md:rd-mt-4': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
    { 'rd-mt-0 md:rd-gap-x-4': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]])
    }, [
      _createVNode(ValidatedInput, {
        id: __props.id,
        value: address.value.city,
        label: __props.cityLabel,
        accessibleLabel: __props.cityPlaceholder,
        name: __props.name + '.Address.City',
        class: _normalizeClass(["rd-w-full md:rd-flex-equal", [{ 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
            { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]]),
        isRequired: __props.required,
        maxLength: 50
      }, {
        input: _withCtx((inputProps) => [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((address.value.city) = $event)),
            placeholder: __props.cityPlaceholder,
            "aria-describedby": inputProps.describedBy ?? undefined,
            "aria-required": inputProps.required,
            "aria-invalid": inputProps.isInvalid,
            id: __props.id + '_' + __props.name + '.Address.City',
            autocomplete: __props.isShipping ? 'shipping address-level2' : 'billing address-level2'
          }, null, 8, _hoisted_2), [
            [_vModelText, address.value.city]
          ])
        ]),
        _: 1
      }, 8, ["id", "value", "label", "accessibleLabel", "name", "class", "isRequired"]),
      _createVNode(ValidatedInput, {
        id: __props.id,
        value: address.value.state,
        label: __props.stateLabel,
        "label-for": `${__props.id}_${__props.name}_Address_State`,
        accessibleLabel: __props.statePlaceholder,
        name: __props.name + '_Address_State',
        class: _normalizeClass(["rd-w-full md:rd-flex-equal", [{ 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
            { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) },
            { 'md:rd-mt-[.3125rem]': (fieldStyle.value == _unref(FieldStyle).Underline && isModalDisplay.value) }]]),
        isRequired: __props.required,
        maxLength: 50
      }, {
        input: _withCtx((inputProps) => [
          _createVNode(_unref(VueMultiselect), {
            id: `${__props.id}_${__props.name}_Address_State`,
            label: "text",
            placeholder: __props.statePlaceholder,
            "track-by": "value",
            "select-label": "",
            "selected-label": "",
            "deselect-label": "",
            class: "multiselect-element",
            modelValue: stateSelection.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stateSelection).value = $event)),
            "aria-describedby": inputProps.describedBy,
            "aria-required": inputProps.required,
            "aria-invalid": inputProps.isInvalid,
            options: __props.states,
            autocomplete: __props.isShipping ? 'shipping address-level1' : 'billing address-level1',
            onOpen: _cache[3] || (_cache[3] = ($event: any) => (isStateOpen.value = true)),
            onClose: _cache[4] || (_cache[4] = ($event: any) => (isStateOpen.value = false)),
            "aria-autocomplete": "list",
            "aria-expanded": isStateOpen.value,
            "aria-controls": `${__props.id}_${__props.name}_Address_State`,
            "aria-label": "Select a state from the dropdown list"
          }, null, 8, ["id", "placeholder", "modelValue", "aria-describedby", "aria-required", "aria-invalid", "options", "autocomplete", "aria-expanded", "aria-controls"])
        ]),
        _: 1
      }, 8, ["id", "value", "label", "label-for", "accessibleLabel", "name", "class", "isRequired"]),
      _createVNode(ValidatedInput, {
        id: __props.id,
        value: address.value.postal,
        label: __props.postalLabel,
        accessibleLabel: __props.postalPlaceholder,
        name: __props.name + '.Address.Postal',
        class: _normalizeClass(["rd-w-full md:rd-flex-equal", [{ 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value }, { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]]),
        isRequired: __props.required,
        maxLength: 50
      }, {
        input: _withCtx((inputProps) => [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((address.value.postal) = $event)),
            placeholder: __props.postalPlaceholder,
            "aria-describedby": inputProps.describedBy ?? undefined,
            "aria-required": inputProps.required,
            "aria-invalid": inputProps.isInvalid,
            id: __props.id + '_' + __props.name + '.Address.Postal',
            autocomplete: "off"
          }, null, 8, _hoisted_3), [
            [_vModelText, address.value.postal]
          ])
        ]),
        _: 1
      }, 8, ["id", "value", "label", "accessibleLabel", "name", "class", "isRequired"])
    ], 2)
  ], 64))
}
}

})